import React, { CSSProperties, useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import styles from './video-tiles.module.scss';
import Richtext from '../global/richtext/Richtext';
import Player from '../player/Player';
import VideoTilesModel from '../../models/video-tiles';
import breakpoints from '../../constants/break-points';

const VideoTiles = ({ color, videoTiles }: VideoTilesModel) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.md}px)`);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  const tileStyle = (
    textPosition: 'bottom' | 'top',
    customStyles?: CSSProperties,
    media?: boolean
  ) => {
    if (mobile) {
      return undefined;
    }
    const tileStyles = { ...customStyles } || {};
    const { gridRow } = tileStyles;

    if (gridRow) {
      if (media) {
        tileStyles.gridRow = Number(gridRow) + (textPosition === 'top' ? 0 : 1);
        tileStyles.alignSelf = textPosition === 'top' ? 'end' : 'unset';
      } else {
        tileStyles.gridRow = Number(gridRow) + (textPosition === 'top' ? 1 : 0);
      }
    }
    return tileStyles;
  };

  return (
    <div className={styles.videoTiles} style={{ color }}>
      {!!videoTiles?.length &&
        videoTiles.map((item) => {
          const {
            name,
            text,
            inlineMedia,
            fullscreenMedia,
            cursor,
            customStyles,
            thumbnail,
            textPosition
          } = item;

          return (
            <React.Fragment key={name}>
              {inlineMedia && (
                <div
                  className={styles.videoTiles__tile}
                  style={tileStyle(textPosition, customStyles)}
                >
                  {inlineMedia.isImage() ? (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                      src={inlineMedia.src}
                      alt={inlineMedia.title}
                      className={styles['videoTiles__tile-image']}
                    />
                  ) : (
                    <Player
                      inlineMedia={inlineMedia}
                      fullscreenMedia={fullscreenMedia}
                      thumbnail={thumbnail}
                      cursor={cursor}
                    />
                  )}
                </div>
              )}
              {text && (
                <div
                  className={styles.videoTiles__tile}
                  style={tileStyle(textPosition, customStyles, !!inlineMedia)}
                >
                  <Richtext
                    data={text}
                    customClasses={{ container: styles.videoTiles__text }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default VideoTiles;
